if (!window.customProductGalleryArrowsBound) {
window.customProductGalleryArrowsBound = true;
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-gallery-direction]');
  if (!button) return;
  const gallery = button.closest('media-gallery');
  const viewer = gallery?.querySelector('[id^="GalleryViewer-"]');
  if (!viewer || typeof gallery.setActiveMedia !== 'function') return;
  const slides = Array.from(viewer.querySelectorAll('.product__media-list > .product__media-item[data-media-id]'));
  if (slides.length < 2) return;
  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  // Swiping on mobile updates scroll position rather than the active CSS class.
  if (window.matchMedia('(max-width: 749px)').matches) {
    const visible = slides.filter((slide) => slide.getClientRects().length);
    const viewport = viewer.querySelector('ul').getBoundingClientRect();
    const closest = visible.reduce((best, slide) =>
      Math.abs(slide.getBoundingClientRect().left - viewport.left) <
      Math.abs(best.getBoundingClientRect().left - viewport.left) ? slide : best, visible[0]);
    if (closest) index = slides.indexOf(closest);
  }
  const next = (Math.max(0, index) + Number(button.dataset.galleryDirection) + slides.length) % slides.length;
  gallery.setActiveMedia(slides[next].dataset.mediaId, false);
});

}
